import * as Api from "api";
import { GET_ACCESSORIALS } from "constants/accessorials";
import { networkAction } from "helpers/network/networkAction";

export const getAccessorials = (customerID) => async (dispatch) =>
  networkAction(dispatch, GET_ACCESSORIALS, Api.getAccessorials, [customerID]);
